export default "__VITE_PUBLIC_ASSET__cc15dd7a__"